var React = require('react');

function ZoomIn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31.918 27.547a15.84 15.84 0 00-21.97-21.97 15.84 15.84 0 1021.969 21.97zm2.418 1.616a18.749 18.749 0 10-32.909-17.59 18.75 18.75 0 0024.496 24.496 18.748 18.748 0 008.413-6.906z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.856 18.618c0-.803.651-1.454 1.455-1.454h18.617a1.455 1.455 0 010 2.909H9.31a1.455 1.455 0 01-1.455-1.455z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.62 7.854c.803 0 1.454.652 1.454 1.455v18.618a1.455 1.455 0 01-2.91 0V9.31c0-.803.652-1.455 1.455-1.455zm12.357 23.12a1.454 1.454 0 012.057 0l14.54 14.543a1.455 1.455 0 01-2.057 2.057L30.977 33.03a1.455 1.455 0 010-2.057z","key":2})]);
}

ZoomIn.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ZoomIn;

ZoomIn.default = ZoomIn;
